import React, { useState } from "react";
import styled from "styled-components";
import { FiMenu } from "react-icons/fi";
import { FiXCircle } from "react-icons/fi";
import { Link } from "react-scroll";
import Scrollspy from "react-scrollspy";

function Navbar() {
  const [open, setOpen] = useState(false);

  function buttonClick() {
    setOpen(!open);
  }

  return (
    <Container>
      <nav>
        <div className="navbar-container main-container">
          <Link to="home" smooth={true} name="home-logo">
            <h3 className="notranslate logo">Will</h3>
          </Link>

          <ul className={open ? "nav-enable" : ""}>
            <Scrollspy
              items={["home", "about", "experience", "projects", "contact"]}
              currentClassName="active"
              className={open ? "nav-enable" : ""}
            >
              <Link
                smooth={true}
                to="home"
                className="notranslate home-Link"
                onClick={() => buttonClick()}
                name="home"
              >
                Home
              </Link>
              <Link
                smooth={true}
                to="about"
                className="about-Link"
                onClick={() => buttonClick()}
                name="about"
              >
                <li>About</li>
              </Link>

              <Link
                smooth={true}
                to="experience"
                className="experience-Link"
                onClick={() => buttonClick()}
                name="experience"
              >
                <li>Experience</li>
              </Link>
              <Link
                smooth={true}
                to="projects"
                className="projects-Link"
                onClick={() => buttonClick()}
                name="projects"
              >
                <li>Projects</li>
              </Link>
              <Link
                smooth={true}
                to="contact"
                className="contact-Link"
                onClick={() => buttonClick()}
                name="contact"
              >
                <li>Contact me</li>
              </Link>
              <a className="animation start-home" name="animation"></a>
            </Scrollspy>
          </ul>
          <span onClick={() => buttonClick()} className="button-color">
            {open ? <FiXCircle /> : <FiMenu />}
          </span>
        </div>
      </nav>
    </Container>
  );
}

export default Navbar;

const Container = styled.div`
  nav {
    width: 100%;
    height: 5rem;
    background: var(--color-white);
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    z-index: 2;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  }

  .logo {
    font-weight: bold;
    font-size: 31px;
    font-family: Calibri;
  }

  nav .navbar-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
  }

  nav span {
    display: none;
    cursos: pointer;
  }

  nav h3 {
    color: var(--color-primary);
    cursor: pointer;
  }

  nav .main-container ul {
    display: flex;
    height: 100%;
  }
  .homelink {
    color: white;
  }
  a {
    cursor: pointer;
    font-weight: bold;
  }

  nav .main-container ul a {
    height: 100%;
    width: 7rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--color-black);
    position: relative;
    transition: var(--transition);
  }

  nav .main-container ul a:hover {
    color: var(--color-white);
  }

  a:nth-child(1).active {
    color: var(--color-white);
  }
  a:nth-child(2).active {
    color: var(--color-white);
  }
  a:nth-child(3).active {
    color: var(--color-white);
  }
  a:nth-child(4).active {
    color: var(--color-white);
  }
  a:nth-child(5).active {
    color: var(--color-white);
  }
  a:nth-child(6).active {
    color: var(--color-white);
  }

  a.active {
    background: var(--color-primary);
    color: var(--color-white);
  }

  nav a {
    position: relative;
    z-index: 1;
  }
  nav .animation {
    position: absolute;
    height: 100%;
    top: 0;
    z-index: -1;
    background: var(--color-black);
    transition: all 2 ease 20s;
  }
  nav .home-Link {
    width: 100px;
  }

  .start-home,
  .home-Link ~ .animation {
    width: 100px;
    left: -830px;
  }

  .start-home,
  .home-Link:hover ~ .animation {
    width: 100px;
    left: -625px;
  }
  nav .about-Link {
    width: 100px;
  }
  nav .about-Link:hover ~ .animation {
    width: 100px;
    left: -522px;
  }
  .skills-Link {
    width: 100px;
  }
  .skills-Link:hover ~ .animation {
    width: 100px;
    left: -420px;
  }
  .experience-Link {
    width: 100px;
  }
  .experience-Link:hover ~ .animation {
    width: 100px;
    left: -312px;
  }
  .projects-Link {
    width: 115px;
  }
  .projects-Link:hover ~ .animation {
    width: 100px;
    left: -210px;
  }

  .contact-Link {
    width: 120px;
  }
  .contact-Link:hover ~ .animation {
    width: 100px;
    left: -105px;
  }

  .button-color {
    color: var(--color-black);
    font-weight: bold;
  }

  @media screen and (max-width: 700px) {
    nav ul {
      display: flex;
      position: fixed;
      top: 0;
      flex-direction: column;
      z-index: 3;
      width: 20rem;
      background: var(--color-white);
      box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
        rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
        rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
      transition: transform 0.2s ease-out;
      transform: translateX(-100%);
      padding: 5px;
      justify-content: start;
    }

    nav {
      height: 4rem;
    }

    .nav-enable {
      transform: translateX(-1%);
    }

    nav h3 {
      margin-left: 1rem;
    }

    nav .main-container {
      width: 100%;
    }

    nav ul a li {
      height: 4.6rem;
    }

    nav .animation {
      display: none;
    }

    nav .main-container ul a.active {
      width: 100%;
      justify-content: start;
      padding-left: 2rem;
      border-radius: 5px;
    }

    nav .main-container ul a:hover {
      width: 100%;
      justify-content: start;
      padding-left: 2rem;
      background: var(--color-black);
      border-radius: 5px;
    }

    nav span {
      display: block;
      cursor: pointer;
      background: transparent;
      color: var(--color-back);
      margin-right: 1rem;
      font-size: 2.2rem;
    }
  }
`;
